(function(){


    var elems = document.querySelectorAll('#home-s2, #home-section--world-renowned');

    //console.log(elems);

    var wrapperElem = document.createElement('div');
    //wrapperElem.className = 'wrapper-abc';
    wrapperElem.id = 'home-section--group';
    elems[0].parentNode.prepend(wrapperElem);

    for (let i = 0; i < elems.length; i++) {
        wrapperElem.appendChild(elems[i]);
    }

    var mq = window.matchMedia("(min-width: 992px)");

/**/
    //gsap.registerPlugin(ScrollTrigger);

    (function(){
        var canvas = document.getElementById('box-4');
        if (!canvas) return;

        var args = {
            images: [],
            frame: 0,
            frameCount: canvas.dataset.frameCount,
            frameUrl: canvas.dataset.frameUrl,
            iWidth: 1140,
            iHeight: 380,
            cWidth: 1140,
            cHeight: 380,
            size: 'cover', // cover, fit
        }

        var context = canvas.getContext('2d');

        canvas.width = args.cWidth;
        canvas.height = args.cHeight;
        //canvas.height = 0;

        // find number pattern count
        var pattern = args.frameUrl.match(/\{(\d{1,})\}/g);
        pattern = pattern[0] ? pattern[0] : '';
        var nStr = pattern.replace(/\{|\}/g, '');
        var nCount = nStr.length ? nStr.length : 4;

        function getCurrentFrame(index) {
            return args.frameUrl.replace(pattern, (index + 1).toString().padStart(nCount, '0'));
        }

        function render() {
            //console.log('img == ', args.images[args.frame]);
            context.clearRect(0, 0, args.cWidth, args.cHeight);
            if ('cover' == args.size) context.drawImage(args.images[args.frame], (args.cWidth-args.iWidth)/2, (args.cHeight-args.iHeight)/2, args.iWidth, args.iHeight);
            else context.drawImage(args.images[args.frame], 0, 0, args.cWidth, args.cHeight);
        }

        // preload first image
        let img = new Image();
        img.onload = render;
        img.src = getCurrentFrame(0);
        args.images.push(img);

        if (mq.matches) {
            // preload images
            for (let i = 1; i < args.frameCount; i++) {
                let img = new Image();
                img.src = getCurrentFrame(i);
                args.images.push(img);
            }
            gsap.to(args, {
                frame: args.frameCount - 1,
                snap: 'frame',
                scrollTrigger: {
                    //markers: true,
                    trigger: '#home-section--group',
                    scrub: true,
                    pin: true,
                    start: "420px 500px",
                    end: "+=100%",
                },
                onUpdate: render
            });
        }
    })();

    // ----

    (function(){
        var canvas = document.getElementById("device");
        if (!canvas) return;

        var args = {
            images: [],
            frame: 0,
            frameCount: canvas.dataset.frameCount,
            frameUrl: canvas.dataset.frameUrl,
            iWidth: 600,
            iHeight: 600,
            cWidth: 600,
            cHeight: 600,
            size: 'cover', // cover, fit
        };

        var context = canvas.getContext('2d');

        canvas.width = args.cWidth;
        canvas.height = args.cHeight;

        // find number pattern count
        var pattern = args.frameUrl.match(/\{(\d{1,})\}/g);
        pattern = pattern[0] ? pattern[0] : '';
        var nStr = pattern.replace(/\{|\}/g, '');
        var nCount = nStr.length ? nStr.length : 4;

        function getCurrentFrame(index) {
            return args.frameUrl.replace(pattern, (index + 1).toString().padStart(nCount, '0'));
        }

        // preload images
        for (let i = 0; i < args.frameCount; i++) {
            let img = new Image();
            if (0===i) img.onload = render;
            img.src = getCurrentFrame(i);
            args.images.push(img);
        }
    
        gsap.to(args, {
            frame: args.frameCount - 1,
            snap: 'frame',
            scrollTrigger: {
                //id: 'wr',
                //markers: true,
                pinnedContainer: '#home-section--group',
                trigger: document.querySelector('.home-section--world-renowned'),
                scrub: 0.5,
                //pin: true,
                start: "-10% center",
                end: "50% center"
            },
            onUpdate: render
        });
    
        function render() {
            //console.log('img == ', args.images[args.frame]);
            context.clearRect(0, 0, args.cWidth, args.cHeight);
            if ('cover' == args.size) context.drawImage(args.images[args.frame], (args.cWidth-args.iWidth)/2, (args.cHeight-args.iHeight)/2, args.iWidth, args.iHeight);
            else context.drawImage(args.images[args.frame], 0, 0, args.cWidth, args.cHeight);
        }
        
    })();
})();
